import { jsxs as s, jsx as e } from "react/jsx-runtime";
import i from "classnames";
import o from "./index.es570.js";
import { useIsMessageTwoLine as L } from "./index.es571.js";
import { CalloutPrimitive as N } from "./index.es572.js";
import { CalloutGroup as h } from "./index.es573.js";
import { BodyText as a } from "./index.es487.js";
const g = "callout-component", v = ({
  text: m,
  valueText: c,
  testId: p = g,
  FreeTextIcon: t,
  isCondensed: l = !1,
  CTA: n
}) => {
  const f = i(o.content, { [o.freeText]: !!t }), { containerRef: u, is2Liner: r } = L(30), d = i(o.textContainer, {
    [o.is2Liner]: r
  }), C = i(o.icon, {
    [o.is2Liner]: r
  });
  return /* @__PURE__ */ s(N, { testId: p, isCondensed: l, isHugging: !!t, children: [
    /* @__PURE__ */ s("div", { className: d, children: [
      /* @__PURE__ */ e("span", { className: C, children: t }),
      /* @__PURE__ */ s("div", { className: f, ref: u, children: [
        /* @__PURE__ */ e(a, { element: "label", children: m }),
        t && n ? n : null
      ] })
    ] }),
    !l && !t && /* @__PURE__ */ e(a, { variant: "bold", element: "p", children: c })
  ] });
};
v.CalloutGroup = h;
export {
  g as CALLOUT_DEFAULT_TESTID,
  v as Callout
};
//# sourceMappingURL=index.es19.js.map
